<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12">	    			
			<h1>
				Smart List: RADAR
				<span class="d-none d-md-inline text-transform-none font-weight-normal" style="letter-spacing:0;">(New, local physicians identified as most likely to refer patients.)</span>
			</h1>
			<div v-if="data_loaded" class="page-with-title">

				<physician-map-and-table
		            :physician_data="physician_data"
		            :physician_fields_override="physician_fields"
		            :default_lat="location_type == 'user' ? user_location.latitude : client_location.latitude"
		            :default_lng="location_type == 'user' ? user_location.longitude : client_location.longitude"
		            default_sort_field="medicare_services"
		            default_sort_direction="desc"
		            :default_per_page="100"
		            :data_loaded="data_loaded"
		            :save_physicians_first="true"
		            :hide_search_within_map_prop="true" >
		            
		            <!-- Filters -->
		            <div class="col-auto">
		                <select class="col-auto form-control form-control-sm" v-model="location_type">
		                    <option v-if="user_location.latitude" value="user">Use my location</option>
		                    <option value="client">Use facility Location</option>
		                </select>
		            </div>

		            <div class="col-auto">
		                <div class="input-group input-group-sm">
		                    <input type="text" class="form-control form-control-sm text-right" style="border-right:none; width:40px" id="inlineFormInputGroup" v-model="radius">
		                    <div class="input-group-append">
		                        <div class="input-group-text text-muted pl-0" style="background:#fff;">miles</div>
		                    </div>              
		                </div>
		            </div>

		            <div class="col-auto">
		               <span class="btn btn-primary btn-sm" @click="searchRadar()">Search</span>
		            </div>   
		            <!-- End Filters -->

	        	</physician-map-and-table>
			</div>

			<div v-else class="page-with-title fill-app-height">
				<img class="center-me" src="/images/loading-color.svg">
			</div>
		</div>
	</div>
</div>
</template>

<script>
    import { mapState } from 'vuex'
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
		
	export default {

	mixins: [BreadcrumbsManager],
    data() {
		return {
	        data_loaded: false,

	        physician_data: [],
	        
	        user_location: {
	           latitude: null,
	           longitude: null,	      	
	        },

	        client_location: {},

	        location_type: 'client',
	        radius: 2,

	        physician_fields: [           
	          {
	            name: 'last_name',
	            title: 'Name',
	            sortField: 'last_name',
	            visible: true,
	            width: '240px',               
	            visibility: {
                	def: true,
                	lim: true,
                	min: true,
                	mob: true,
                },
	          },        
	          { 
	            name: 'address',
	            title: 'Location',
	            visible: true,
	            width: '150px',
                visibility: {
                	def: true,
                	lim: true,
                	min: false,
                	mob: true,
                },	            
	          },
	          // { 
	          //   name: 'phone',
	          //   title: 'Phone',
	          //   formatter (value) {
	          //     return numeral(value).format('(NNN) NNN-NNNN');
	          //   },
	          //   visible: true,
	          //   width: '150px',
	          // },
	          {
	            name: 'medicare_average_submitted_chrg_amt',
	            title: 'Avg. Charge',
	            formatter (value) {
	            	return numeral(value).format('($0,0)')
	            },
	            sortField: 'medicare_average_submitted_chrg_amt',
	            visible: true,
	            width: '110px',
	            visibility: {
                	def: true,
                	lim: false,
                	min: false,
                	mob: false,
                },
	          },          
	          {
	            name: 'medicare_services',
	            title: '# Services',
	            sortField: 'medicare_services',
	            visible: true,
	            width: '100px',
	            visibility: {
                	def: true,
                	lim: false,
                	min: false,
                	mob: false,
                },
	          },
	          // {
	          //   name: 'actions',
	          //   title: '',
	          // },
	        ],

	      };
	    },

	    created() {
	    	this.client_location = {
	    		latitude: parseFloat(this.user.client.latitude),
	            longitude: parseFloat(this.user.client.longitude),
	        };
	    	this.getUsersLocation();    	
	    },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Providers', to: { name: 'physicians.list'} },
                { text: 'Smart Lists', to: { name: 'smart_lists.index'} },
                { text: 'RADAR', to: { name: 'smart_lists.radar'} },
            ]); 	
        },

	    methods: {
			//these methods are not great, but works for a wham-bam proof of concept
			getUsersLocation() {
				navigator.geolocation.getCurrentPosition(
					pos => { 
						//set for later
						this.user_location.latitude = pos.coords.latitude;
						this.user_location.longitude = pos.coords.longitude;
						
						//set for radar
						this.location_type = 'user';
						this.getSmartListData();
						},
					  err => {
					  	console.warn(`ERROR(${err.code}): ${err.message}`);
					  	this.getSmartListData();
					  },
					  {
					  	enableHighAccuracy: true,
					  	timeout: 2000,
					  },
					);
			},

	        getSmartListData() {
	          axios.get(window.Laravel.DATAAPP_API_BASE_URL + '/flightplan/physicians_via_radar', {
	            params: {
	              latitude: this.location_type == 'user' ? this.user_location.latitude : this.client_location.latitude,
	              longitude: this.location_type == 'user' ? this.user_location.longitude : this.client_location.longitude,
	              radius: this.radius,
	            }, 
	            headers: {
	              "api-password": window.Laravel.DATAAPP_API_PASSWORD
	            }
	          }).then(({ data }) => { 
	            this.physician_data = this.filterAndUpdatephysician_data(data);
	            this.data_loaded = true;

	            //crude fix to problems with map sizing on initial load
	            setTimeout(() => { this.$root.$emit('map-adjust'); }, 500);
	          });
	        },

	        filterAndUpdatephysician_data(physicians) {         
	            var updated_list = [];
	            
	            physicians.filter(
	            	physician => !this.physicians.physicians.some(
	            		ember_phys => ember_phys.display_name.toLowerCase() == physician.first_name.toLowerCase() + ' ' + physician.last_name.toLowerCase()
	            	)).forEach(physician => {

						var new_physician = physician;
						new_physician.physician_id = physician.id;

						// add display name
						new_physician.display_name = physician.first_name + ' ' + physician.last_name;
						new_physician.initials = physician.first_name.charAt(0) + physician.last_name.charAt(0);

						// add location primary
						new_physician.location_primary = {};
						new_physician.location_primary.id = new_physician.id;
						new_physician.location_primary.primary = 1;
						new_physician.location_primary.show_in_maps = 1;
						new_physician.location_primary.address = physician.address;
						new_physician.location_primary.address_2 = physician.address_2;
						new_physician.location_primary.city = physician.city;
						new_physician.location_primary.state = physician.state;
						new_physician.location_primary.zip = physician.zip;
						new_physician.location_primary.fax = physician.fax;
						new_physician.location_primary.phone = physician.phone;
						new_physician.location_primary.address = physician.address;

						new_physician.location_primary.formatted_address = physician.address;
						new_physician.location_primary.short_address = physician.address;
						if (physician.suite != null) {
							new_physician.location_primary.formatted_address += physician.suite + '<br>';
							new_physician.location_primary.short_address += physician.suite + ' ';
						}
						if (physician.city != null) {
							new_physician.location_primary.formatted_address += physician.city + ',';
							new_physician.location_primary.short_address += physician.city + ' ';
						}
						if (physician.state != null) {
							new_physician.location_primary.formatted_address += physician.state + ' ';
							new_physician.location_primary.short_address += physician.state + ' ';
						}
						if (physician.zip != null) {
							new_physician.location_primary.formatted_address += physician.zip;
							new_physician.location_primary.short_address += physician.zip + ' ';
						}
						new_physician.location_primary.latitude = new_physician.latitude;
						new_physician.location_primary.longitude = new_physician.longitude;

						new_physician.location = [];
						new_physician.location.push(new_physician.location_primary);

						// add markers
						new_physician.location_primary.markers = {
							position: {
							    lat: new_physician.latitude,
							    lng: new_physician.longitude
							}
						};

						updated_list.push(new_physician);

	            });

	            return updated_list;
	        }, 

	        searchRadar() {
	        	this.data_loaded = false;
	        	this.getSmartListData();
	        },

	    },

		computed: mapState(['physicians', 'user'])


	}
</script>